import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { PageHeader, EmptyState } from "../components/Shared";
import { statusBadgeClass, fmtDate } from "../lib/format";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { TableSkeleton } from "../components/Skeletons";
import { Link } from "react-router-dom";

export default function MyProjects() {
  const { data: rows = [], isLoading } = useQuery({ queryKey: ["my-projects"], queryFn: () => api.get("/projects/mine").then((r) => r.data) });
  return (
    <div>
      <PageHeader title="My Projects" subtitle="Projects you're assigned to · read-only" />
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
        {isLoading ? <TableSkeleton cols={5} /> : rows.length === 0 ? (
          <EmptyState text="You are not assigned to any projects yet." />
        ) : (
          <Table>
            <TableHeader><TableRow>
              <TableHead>Project</TableHead><TableHead>Category</TableHead><TableHead>Status</TableHead>
              <TableHead>Start</TableHead><TableHead>End</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {rows.map((p) => (
                <TableRow key={p.id} data-testid={`my-project-${p.id}`}>
                  <TableCell className="font-medium text-slate-800">
                    <Link to={`/projects/${p.id}`} className="hover:text-[#1E3A8A]">{p.name}</Link>
                  </TableCell>
                  <TableCell className="text-slate-600">{p.category || "—"}</TableCell>
                  <TableCell><span className={`px-2 py-0.5 rounded-full text-xs font-semibold border ${statusBadgeClass(p.status)}`}>{p.status}</span></TableCell>
                  <TableCell className="text-slate-600">{p.start_date ? fmtDate(p.start_date) : "—"}</TableCell>
                  <TableCell className="text-slate-600">{p.end_date ? fmtDate(p.end_date) : "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </div>
  );
}
